// extracted by mini-css-extract-plugin
export default {"inputNumber":"AttribuedCarRow_inputNumber__P1Vbg","action":"AttribuedCarRow_action__5m5Xu","inputText":"AttribuedCarRow_inputText__haiVt"};